import { createReducer, on } from '@ngrx/store';
import * as NavActions from '../actions/nav.action';

export interface NavState {
  menuOpen: boolean;
}

export const initialState: NavState = {
  menuOpen: false,
};

export const NavReducer = createReducer(
  initialState,
  on(NavActions.OpenMenu, state => {
    return {
      menuOpen: true,
    };
  }),
  on(NavActions.CloseMenu, state => {
    return {
      menuOpen: false,
    };
  }),
  on(NavActions.ToggleMenu, state => {
    return {
      menuOpen: !state.menuOpen,
    };
  })
);

export const getMenuOpen = (state: NavState) => state.menuOpen;
